<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <div class="left-box flex-shrink" :style="{ width: width + 'px', maxHeight: rightBoxHeight + 'px' }">
      <div class="tree-block pb-lg">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>
        <el-tree node-key="categoryId" :defaultExpandedKeys=[queryParams.parentCategoryId] :current-node-key="queryParams.parentCategoryId" highlight-current class="filter-tree"
          :props="defaultProps" :data="categoryData" :filter-node-method="filterNode" @node-click="handleSelect"
          ref="tree">
        </el-tree>
      </div>
      <xiaobu-drag class="myxhandle" @widthChange="widthChange" />
    </div>
    <div ref="rightBox" id="categoryRightBox" class="right-box flex-grow" :style="{ width: `calc(100% - ${width}px)` }">
      <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field fl five-per-row" label="分类名称" prop="categoryName">
          <el-input v-model.trim="queryParams.categoryName" placeholder="请输入分类名称" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
          <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>

        <el-form-item class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </el-form-item>
      </el-form>
      <div class="table-wrap">
        <div class="table-control-box">
          <el-button v-hasPermission="['product:category:create']" type="primary" plain icon="el-icon-plus" size="mini"
            @click="handleAdd">新增</el-button>
          <el-button v-hasPermission="['product:category:update']" type="success" plain icon="el-icon-edit" size="mini"
            :disabled="single" @click="handleUpdate">编辑</el-button>
          <el-button v-hasPermission="['product:category:delete']" type="danger" plain icon="el-icon-delete" size="mini"
            :disabled="multiple" @click="handleBatchDelete">删除</el-button>
        </div>
        <div class="table-box">
          <auto-height-table ref="categoryTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list" row-key="categoryId" @selection-change="handleSelectionChange"
            @row-click="clickRow">
            <el-table-column :reserve-selection="true" type="selection" width="55" align="center" />
            <el-table-column label="分类名称" prop="categoryName" align="center" min-width="168px" />
            <el-table-column label="操作人" prop="creator.userName" show-overflow-tooltip align="center" min-width="168px">
              <template slot-scope="scope">
                <div class="operater-box flex-c-c">
                  <div class="operater-content-box">
                    <div class="top">
                      <span class="label">创建人：</span>
                      <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">更新人：</span>
                      <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
              <template slot-scope="scope">
                <div class="operater-box flex-c-c">
                  <div class="operater-content-box">
                    <div class="top">
                      <span class="label">创建时间：</span>
                      <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">更新时间：</span>
                      <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="
              mixinHasPermi([
                'product:category:read',
                'product:category:delete',
                'product:category:params',
                'product:category:brand',
                'product:category:skuAttr'
              ])
            " label="操作" align="center" :width="operateWidth + 'px'" fixed="right" class-name="small-padding ">
              <template slot-scope="scope">
                <el-button v-hasPermission="['product:category:read']" size="mini" type="primary" icon="el-icon-view"
                  @click.native.stop="handleUpdate(scope.row)">查看</el-button>
                <el-button v-hasPermission="['product:category:delete']" size="mini" type="danger" icon="el-icon-delete"
                  :disabled="scope.row.hasChildren || scope.row.beUsedInGoods"
                  @click.native.stop="handleDelete(scope.row)">删除</el-button>
                <el-button v-hasPermission="['product:category:params']" size="mini" type="primary" plain
                  @click.native.stop="handleParams(scope.row)">参数配置</el-button>

                <el-button v-hasPermission="['product:category:skuAttr']" v-if="permissionLength <= 3" size="mini"
                  type="primary" plain @click.native.stop="handleSku(scope.row)">规格配置</el-button>
                <el-button v-hasPermission="['product:category:brand']" v-if="permissionLength <= 3" size="mini"
                  type="primary" plain @click.native.stop="handleBrand(scope.row)">品牌配置</el-button>

                <el-dropdown v-if="
                  mixinHasPermi(['product:category:skuAttr', 'product:category:brand']) &&
                  permissionLength > 3
                " @command="(command) => handleCommand(command, scope.row)">
                  <span class="el-dropdown-link more" @click.stop>
                    <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-hasPermission="['product:category:skuAttr']"
                      command="handleSku">规格配置</el-dropdown-item>
                    <el-dropdown-item v-hasPermission="['product:category:brand']"
                      command="handleBrand">品牌配置</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>

    <!-- 添加或编辑对话框 -->
    <category-dialog ref="categoryDialog" :categoryData="categoryData" :props="props" :visible.sync="open"
      :modal-append-to-body="false" :close-on-click-modal="false" :isUpdate="isUpdate" :baseForm="baseForm"
      @close="open = false" @successs="handleCategoryChange" width="1024px">
    </category-dialog>

    <params-dialog v-if="mixinHasPermi(['product:category:params'])" ref="paramsDialog" :title="`参数配置（${categoryName}）`"
      @close="openParams = false" @successs="handleCategoryChange" :visible.sync="openParams"
      :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false" width="666px"
      :categoryId="categoryId" :parentCategoryId="parentCategoryId"></params-dialog>

    <select-sku v-if="mixinHasPermi(['product:category:skuAttr'])" ref="categorySku" :title="selectSkuTitle" width="1000px"
      :visible.sync="showSelectSku" :categoryId="selectCategorySkuId" @close="showSelectSku = false"
      :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"></select-sku>

    <select-brand v-if="mixinHasPermi(['product:category:brand'])" ref="categoryBrand" :title="selectBrandTitle"
      width="1000px" :visible.sync="showSelectBrand" :categoryId="selectCategoryBrandId"
      @close="showSelectBrand = false" :modal-append-to-body="true" :append-to-body="true"
      :close-on-click-modal="false"></select-brand>
  </div>
</template>

<script>
import { categoryApi } from "@/api"
import CategoryDialog from "./components/category-dialog.vue"
import ParamsDialog from "./components/params-dialog.vue"
import SelectSku from "./components/select-sku.vue"
import selectBrand from "./components/select-brand.vue"
import { debounce } from "vue2-element-admin-plugin"
export default {
  name: "productCategoryManage",
  components: {
    CategoryDialog,
    ParamsDialog,
    SelectSku,
    selectBrand
  },
  data() {
    return {
      rightBoxHeight: 500, // 右侧内容高度
      selectBrandTitle: "", // 分配角色标题
      showSelectBrand: false, // 是否显示分配角色
      selectCategoryBrandId: "", // 选择分配sku时 操作的分类id
      selectSkuTitle: "", // 分配角色标题
      showSelectSku: false, // 是否显示分配角色
      selectCategorySkuId: "", // 选择分配sku时 操作的分类id
      categoryId: "", // 分类id
      parentCategoryId: "", // 父级分类id
      categoryName: "", // 分配名称
      openParams: false,
      width: 200,
      categoryData: [], // 分类树 数据
      defaultProps: {
        children: "children",
        label: "categoryName"
      },
      filterText: "",
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        parentCategoryId: "ROOT_VALUE", // 父级分类id
        categoryName: "", // 名称
        status: "", //
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        parentCategoryId: "", // 父级分类
        categoryName: "", // 角色名
        remark: "" // 备注
      },
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {

      },
      props: {
        value: "categoryId",
        label: "categoryName",
        checkStrictly: true,
        emitPath: false
      },
      queryOptions: [],
      options: [] // 分类值父元素id
    }
  },
  computed: {
    // 五个按钮权限中 有多少个按钮权限
    permissionLength() {
      const permissionList = this.$store.getters.permissionList
      const list = [
        "product:category:read",
        "product:category:delete",
        "product:category:params",
        "product:category:brand",
        "product:category:skuAttr"
      ]
      let num = 0
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (permissionList.includes(item)) {
          num++
        }
      }
      return num
    },
    // 计算操作项目表格宽度
    operateWidth() {
      if (this.permissionLength === 1) {
        return 168
      }
      if (this.permissionLength === 2) {
        return 208
      }
      if (this.permissionLength === 3) {
        return 288
      }
      if (this.permissionLength === 4) {
        const permissionList = this.$store.getters.permissionList
        // 如果2个 在更多里
        if (permissionList.includes("product:category:brand") && permissionList.includes("product:category:skuAttr")) {
          return 268
        } else {
          return 328
        }
      }
      return 328
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          parentCategoryId: "", // 父级分类
          categoryName: "", // 角色名
          remark: "" // 备注
        }
        this.$refs.categoryDialog && this.$refs.categoryDialog.resetForm()
      }
    },
    openParams(val) {
      if (!val) {
        this.categoryId = ""
        this.categoryName = ""
        this.$refs.paramsDialog && this.$refs.paramsDialog.resetForm()
      }
    },
    // 展示分配
    showSelectSku(val) {
      if (!val) {
        this.selectCategorySkuId = ""
        this.$refs.categorySku.clearSelection()
        this.selectSkuTitle = ""
      }
    },
    // 展示分配
    showSelectBrand(val) {
      if (!val) {
        this.selectCategoryBrandId = ""
        this.$refs.categoryBrand.clearSelection()
        this.selectBrandTitle = ""
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },

  async created() {
    await this.init()
    this.$nextTick(() => {
      this.rightBoxHeight = this.$refs.rightBox.offsetHeight
    })
  },
  mounted() {
    const element = document.getElementById("categoryRightBox")

    const observer = new ResizeObserver(entries => {
      // for (const entry of entries) {
      //   const width = entry.contentRect.width
      //   console.log(`Element width: ${width}px`)
      // }
      this.resize()
    })

    observer.observe(element)

    //清除监听
    this.$once("hook:beforeDestroy", () => {
      // 停止观察
      observer.disconnect()
    })
  },
  methods: {
    // 重新设置左边的最大高度
    resize: debounce(function(val) {
      this.rightBoxHeight = 500
      setTimeout(() => {
        this.rightBoxHeight = this.$refs.rightBox.offsetHeight
      }, 10)
    }, 300),
    // 分配brand
    handleBrand(row) {
      this.selectBrandTitle = `分配品牌（${row.categoryName}）`
      this.selectCategoryBrandId = row.categoryId
      this.showSelectBrand = true
    },
    // 分配sku
    handleSku(row) {
      this.selectSkuTitle = `分配规格（${row.categoryName}）`
      this.selectCategorySkuId = row.categoryId
      this.showSelectSku = true
    },
    // 入参配置
    handleParams(row) {
      this.categoryId = row.categoryId
      this.parentCategoryId = row.parentCategoryId
      this.categoryName = row.categoryName
      this.openParams = true
    },
    // 更多操作
    handleCommand(command, row) {
      if (command === "handleParams") {
        this.handleParams(row)
      } else if (command === "handleSku") {
        this.handleSku(row)
      } else if (command === "handleBrand") {
        this.handleBrand(row)
      }
    },
    // 初始化
    init() {
      const getArr = [
        this.handleQuery(),
        this.getParentIdList()
      ]
      return Promise.all(getArr)
    },
    // 分类编辑或者新增成功事件
    async handleCategoryChange() {
      await this.init()
    },

    /**
     * @description: 监听拉伸事件
     */
    widthChange(movement) {
      this.width -= movement
      if (this.width < 150) {
        this.width = 150
      }
      if (this.width > 700) {
        this.width = 700
      }
    },
    // 过滤父级分类选项
    filterNode(value, data) {
      if (!value) {
        return true
      }
      return data.categoryName.indexOf(value) !== -1
    },
    // 选中后数据
    handleSelect(data) {
      if (data.categoryId === this.queryParams.parentCategoryId) {
        return
      }
      this.queryParams.pageNum = 1
      if (data) {
        this.queryParams.parentCategoryId = data.categoryId
      } else {
        this.queryParams.parentCategoryId = ""
      }
      // 切换父级分类时 清空已选项
      this.$refs.categoryTable && this.$refs.categoryTable.clearSelection()
      this.getList()
    },
    // 获取分类列表
    getParentIdList() {
      return categoryApi.getCategoryTree().then((data) => {
        if (data.length === 0) {
          this.categoryData = [
            {
              categoryName: "根分类",
              categoryId: "ROOT_VALUE"
            }
          ]
          return
        }
        this.categoryData = [
          {
            categoryName: "根分类",
            categoryId: "ROOT_VALUE",
            children: data
          }
        ]
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.queryParams.parentCategoryId)
        })
      })
    },
    //点击行
    clickRow(row) {
      this.$refs.categoryTable && this.$refs.categoryTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.categoryId)
        str += item.categoryName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认删除分类项为"【' + str + '】"的数据项？')
        .then(function() {
          return categoryApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.init()
          this.$modal.msgSuccess("批量删除分类成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.categoryTable && this.$refs.categoryTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.$refs.tree.setCurrentKey("ROOT_VALUE")
      this.queryParams.parentCategoryId = "ROOT_VALUE"
      this.baseForm.parentCategoryId = "ROOT_VALUE"
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      return categoryApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      if (this.queryParams.parentCategoryId === "") {
        this.$modal.msgWarning("请选择分类节点后再操作！")
        return
      }
      const treeTarget = this.$refs.tree.getCurrentNode()
      const params = {}
      if (treeTarget) {
        params.parentCategoryId = treeTarget.categoryId
      } else {
        params.parentCategoryId = ""
      }

      this.baseForm = Object.assign(this.baseForm, params)
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.categoryId) {
        this.isUpdate = true
      }
      const id = row.categoryId || (this.selection[0] && this.selection[0].categoryId)

      categoryApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.categoryId
      this.$modal
        .confirm('是否确认删除分类为"' + row.categoryName + '"的数据项？')
        .then(function() {
          return categoryApi.deleteItem({ id })
        })
        .then(() => {
          this.init()
          this.$modal.msgSuccess("删除成功")
        })
    },
    // 状态改变事件
    handleStatusChange(row) {
      categoryApi
        .changeStatus({
          categoryId: row.categoryId,
          status: row.status === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.xiaobu-container {
  height: 100%;
  display: flex;

  .left-box {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: calc(100vh - #{$LayoutHeaderHeight} - #{$LayoutTagsHeight} - 40px);
    padding: 12px;
    background: #ffffff;
    border-radius: 4px;
  }

  .right-box {
    padding-left: 12px;
  }

  .tips {
    font-size: 24px;
    margin-left: 12px;
    color: $mainColor;
  }
}
</style>
